import headerObject from './headerObj';

const emptyHeaderObj: headerObject = {
  Useruuid: '',
  Useremail: '',
  Username: '',
  Orguuid: '',
  Orgname: '',
};
export default emptyHeaderObj;
